import React from 'react';
import { Redirect, Route } from 'react-router-dom';
import Session from '../Session';

const ProtectedRoute = ({ component: Component, render, ...rest }) => (
  <Session
    render={({ authenticated, restored }) =>
      restored && (
        <Route
          {...rest}
          render={props =>
            authenticated && render ? (
              render(props)
            ) : authenticated ? (
              <Component {...props} />
            ) : (
              <Redirect to="/unauthorized" />
            )
          }
        />
      )
    }
  />
);

export default ProtectedRoute;



// WEBPACK FOOTER //
// ./src/components/routes/ProtectedRoute.js